module.exports = require("module");


//////////////////
// WEBPACK FOOTER
// external "module"
// module id = 109
// module chunks = 0 1 2